module.exports = __webpack_public_path__ + "static/media/LOGO-GEMINI.a5e66fa3.png";